/** @jsxImportSource @emotion/react */
import { css, keyframes } from '@emotion/react';
import { ReactNode, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import { BackToTop } from '../common';
import { colors } from '../../styles/theme';

interface LayoutProps {
  children: ReactNode;
}

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const mainStyles = css`
  min-height: calc(100vh - 70px);
  background: ${colors.background.secondary};
`;

const pageTransitionStyles = css`
  animation: ${fadeIn} 0.35s ease-out;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

export default function Layout({ children }: LayoutProps) {
  const location = useLocation();
  const [transitionKey, setTransitionKey] = useState(location.pathname);

  useEffect(() => {
    setTransitionKey(location.pathname);
    // html'deki smooth scroll'a takılmadan yeni sayfanın en üstünden başla
    window.scrollTo({ top: 0, behavior: 'instant' as ScrollBehavior });
  }, [location.pathname]);

  return (
    <>
      <Header />
      <main css={mainStyles}>
        <div key={transitionKey} css={pageTransitionStyles}>
          {children}
        </div>
      </main>
      <Footer />
      <BackToTop />
    </>
  );
}
